<template>
    <div class="page-container">
        <van-nav-bar title="监播" left-arrow @click-left="$router.push('/screenControl')" />
        <div
            v-loading="loading"
            v-loading.lock="true"
            class="mobileBox"
            element-loading-background="rgba(0, 0, 0, 0.4)"
            element-loading-custom-class="content-loading"
            element-loading-spinner="el-icon-loading"
            element-loading-text="加载中..."
        >
            <div
                v-infinite-scroll="scrollbar"
                :infinite-scroll-delay="200"
                :infinite-scroll-distance="50"
                :infinite-scroll-immediate="false"
                class="mobile"
            >
                <!-- 筛选区域 -->
                <div class="filter-section">
                    <div class="filter-row">
                        <el-input
                            v-model="filterForm.name"
                            placeholder="输入媒体名称搜索"
                            clearable
                            size="mini"
                            class="filter-input"
                            @keyup.enter.native="handleSearch"
                        >
                            <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
                        </el-input>
                    </div>
                    <div class="filter-row">
                        <el-select v-model="filterForm.province" placeholder="省份" size="mini" clearable class="filter-select" @change="onProvinceChange">
                            <el-option v-for="item in regionData" :key="item.name" :label="item.name" :value="item.name" />
                        </el-select>
                        <el-select v-model="filterForm.city" placeholder="城市" size="mini" clearable class="filter-select" @change="onCityChange" :disabled="!filterForm.province">
                            <el-option v-for="item in cityOptions" :key="item.name" :label="item.name" :value="item.name" />
                        </el-select>
                        <el-select v-model="filterForm.district" placeholder="区县" size="mini" clearable class="filter-select" :disabled="!filterForm.city">
                            <el-option v-for="item in districtOptions" :key="item" :label="item" :value="item" />
                        </el-select>
                    </div>
                </div>
                <div
                    v-for="(item, index) in gridList"
                    :key="index"
                    class="cneten"
                    :ref="`motScreenParent_${item.mediaId}`"
                    @click="openPreview(item)"
                >
                    <template v-if="+item.terminalState === 0 || +item.terminalState === 2">
                        <Material :src="item.coverThumbnailUrl ? item.coverThumbnailUrl : getUrl(item.realPictureUrl)"
                                  class="player" isSelected/>
                    </template>
                    <MonitorScreen v-else :screenInfo="item"></MonitorScreen>
                    <div class="status">
                        <div
                            :class="+item.terminalState === 1 ? 'circle success' : item.terminalState == 2 ? 'circle error' : 'circle warning'"
                        ></div>
                        <span>{{ item.turnTime }}</span>
                    </div>
                  <span class="modle">{{ currentTime }}</span>
                  <span class="tag">{{ item.city + item.district + item.screenName }} {{ item.screenResolution || '--' }}</span>
                </div>
            </div>
        </div>

        <!-- 全屏预览弹窗 -->
        <div v-if="previewVisible" class="preview-overlay" @click="closePreview">
            <div class="preview-close" @click="closePreview">
                <i class="el-icon-close"></i>
            </div>
            <div class="preview-content" :style="previewStyle" @click.stop>
                <template v-if="previewItem">
                    <template v-if="+previewItem.terminalState === 0 || +previewItem.terminalState === 2">
                        <template v-if="isVideoUrl(getPreviewUrl(previewItem))">
                            <video
                                :src="getPreviewUrl(previewItem)"
                                class="preview-media"
                                controls
                                autoplay
                                playsinline
                                webkit-playsinline
                            ></video>
                        </template>
                        <template v-else>
                            <img :src="getPreviewUrl(previewItem)" class="preview-media" />
                        </template>
                    </template>
                    <template v-else>
                        <MonitorScreen :screenInfo="previewItem" :previewContainerW="previewContainerW" :previewContainerH="previewContainerH" :key="'preview_' + previewItem.mediaId"></MonitorScreen>
                    </template>
                </template>
            </div>
        </div>
    </div>
</template>

<script>

import MonitorScreen from './mobile/MonitorScreen';
import Material from './mobile/Material';
import { regionData, toBackendDistrict, toDisplayDistrict } from '@/utils/regionData';

export default {
    components: {
        MonitorScreen,
        Material,
    },
    name: 'HomeView',
    data() {
        return {
            launch_play_type: {1: '轮播模式', 2: '车媒模式', 3: '智能模式'},
            regionData,
            gridList: [],
            filterForm: {
                pageNum: 0,
                pageSize: 5,
                pointName: '',
                name: '',
                province: '',
                city: '',
                district: '',
                superviseLevelList: [1, 2],
            },
            loading: false,
            isSearchAction: false,
            total: 0,
            currentMaxPage: 0,
            currentTime: '',
            timer: null,
            previewVisible: false,
            previewItem: null,
            previewStyle: {},
            previewContainerW: 0,
            previewContainerH: 0,
            isPhoneLandscape: false,
        };
    },
    mounted() {
        this.queryPageList();
        this.updateTime();
        this.timer = setInterval(this.updateTime, 1000);
    },
    computed: {
        cityOptions() {
            if (!this.filterForm.province) return [];
            const province = this.regionData.find(r => r.name === this.filterForm.province);
            return province ? province.city : [];
        },
        districtOptions() {
            if (!this.filterForm.province || !this.filterForm.city) return [];
            const province = this.regionData.find(r => r.name === this.filterForm.province);
            if (!province) return [];
            const city = province.city.find(c => c.name === this.filterForm.city);
            return city ? city.area || [] : [];
        },
    },
    beforeDestroy() {
        if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
        }
        if (this._orientationHandler) {
            window.removeEventListener('orientationchange', this._orientationHandler);
            window.removeEventListener('resize', this._orientationHandler);
        }
    },
    methods: {
        onProvinceChange() {
            this.filterForm.city = '';
            this.filterForm.district = '';
        },
        onCityChange() {
            this.filterForm.district = '';
        },
        handleSearch() {
            this.gridList = [];
            this.filterForm.pageNum = 0;
            this.currentMaxPage = 0;
            this.total = 0;
            this.isSearchAction = true;
            this.queryPageList();
        },
        updateTime() {
            const now = new Date();
            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, '0');
            const day = String(now.getDate()).padStart(2, '0');
            const hours = String(now.getHours()).padStart(2, '0');
            const minutes = String(now.getMinutes()).padStart(2, '0');
            const seconds = String(now.getSeconds()).padStart(2, '0');
            this.currentTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        },
        getUrl(url) {
            const {resourceUrl} = require('@/utils/base');
            return url ? resourceUrl + url : '';
        },
        // 解析分辨率，返回宽高
        parseResolution(item) {
            const resolution = item.screenResolution || '';
            if (resolution) {
                const parts = resolution.split(/[*xX]/);
                if (parts.length === 2) {
                    const width = parseInt(parts[0], 10);
                    const height = parseInt(parts[1], 10);
                    if (!isNaN(width) && !isNaN(height) && width > 0 && height > 0) {
                        return { width, height };
                    }
                }
            }
            return { width: 1920, height: 1080 };
        },
        // 判断是否为视频URL
        isVideoUrl(url) {
            if (!url) return false;
            return url.toLowerCase().endsWith('.mp4');
        },
        // 获取预览URL
        getPreviewUrl(item) {
            if (item.coverThumbnailUrl) {
                return item.coverThumbnailUrl;
            }
            return this.getUrl(item.realPictureUrl);
        },
        // 打开预览
        openPreview(item) {
            this.previewItem = item;
            this.updatePreviewLayout();
            this.previewVisible = true;
            document.body.style.overflow = 'hidden';

            // 监听屏幕旋转
            this._orientationHandler = () => this.updatePreviewLayout();
            window.addEventListener('orientationchange', this._orientationHandler);
            window.addEventListener('resize', this._orientationHandler);
        },
        // 根据手机方向和内容方向计算预览布局
        updatePreviewLayout() {
            const item = this.previewItem;
            if (!item) return;
            const { width, height } = this.parseResolution(item);

            const isContentLandscape = width > height;
            this.isPhoneLandscape = window.innerWidth > window.innerHeight;

            let previewW, previewH;

            // 横屏内容 + 手机竖屏 → 需要旋转90度
            if (isContentLandscape && !this.isPhoneLandscape) {
                const screenW = window.innerHeight - 40;
                const screenH = window.innerWidth - 40;
                const contentRatio = width / height;
                const screenRatio = screenW / screenH;

                if (contentRatio > screenRatio) {
                    previewW = screenW;
                    previewH = previewW / contentRatio;
                } else {
                    previewH = screenH;
                    previewW = previewH * contentRatio;
                }

                this.previewContainerW = previewW;
                this.previewContainerH = previewH;
                this.previewStyle = {
                    width: `${previewW}px`,
                    height: `${previewH}px`,
                    transform: 'rotate(90deg)',
                };
            } else {
                // 横屏内容+手机横屏 或 竖屏内容：正常显示
                const screenW = window.innerWidth;
                const screenH = window.innerHeight - 40;
                const contentRatio = width / height;
                const screenRatio = screenW / screenH;

                if (contentRatio > screenRatio) {
                    previewW = screenW;
                    previewH = previewW / contentRatio;
                } else {
                    previewH = screenH;
                    previewW = previewH * contentRatio;
                }

                this.previewContainerW = previewW;
                this.previewContainerH = previewH;
                this.previewStyle = {
                    width: `${previewW}px`,
                    height: `${previewH}px`,
                };
            }
        },
        // 关闭预览
        closePreview() {
            this.previewVisible = false;
            this.previewItem = null;
            this.previewStyle = {};
            document.body.style.overflow = '';
            // 移除旋转监听
            if (this._orientationHandler) {
                window.removeEventListener('orientationchange', this._orientationHandler);
                window.removeEventListener('resize', this._orientationHandler);
                this._orientationHandler = null;
            }
        },
        // 2. 滚动加载时，更新分页标记
        scrollbar() {
            console.log("jlll")
            console.log("this.gridList.length",this.gridList.length)
            console.log("this.total",this.total)
            if (this.gridList.length < this.total) {
                // this.filterForm.pageSize += 10;
                this.filterForm.pageNum += 1;
                // 记录当前要加载的是第几页（pageNum = currentMaxPage + 1）
                const targetPage = this.currentMaxPage + 1;
                this.queryPageList(targetPage); // 传递目标页码
            }
        },
        queryPageList(targetPage) {
            this.loading = true;
            let params = {...this.filterForm};
            params.district = toBackendDistrict(params.district);
            this.$post("/monitor/queryPageListV4", params, {timeout: 30000})
                .then((res) => {
                    if (res.rescode === 200) {
                        res.data.dataList.forEach((item) => {
                            item.district = toDisplayDistrict(item.district);
                        })
                        // 1. 临时存储当前页原始数据（不直接更新 gridList）
                        const newDataTemp = res.data.dataList;
                        this.total= res.data.totalCount;
                        // 搜索时弹出提示
                        if (this.isSearchAction) {
                            this.$toast(`当前搜索${this.total}条数据`);
                            this.isSearchAction = false;
                        }
                        // 2. 先把新数据追加到「临时完整列表」（模拟 gridList 的最终结构，但不渲染）
                        const tempGridList = [...this.gridList, ...newDataTemp];
                        // 3. 调用 getPlanList，但传递「临时数据」，并让它返回完整的补全后数据
                        this.getPlanList(newDataTemp, tempGridList, targetPage);
                    } else {
                        this.$toast(res.msg);
                    }
                })
                .catch((error) => {
                    this.filterForm.pageNum -= 1;
                    this.loading = false;
                    console.log(error);
                })
                .finally(() => {
                });
        },

        // 改造：接收临时数据、临时完整列表、总条数、目标页码
        getPlanList(currentPageData, tempGridList,targetPage) {
            // 筛选需要请求 plan 的数据
            const forms = currentPageData
                .filter(item => +item.terminalState === 1)
                .map(item => ({
                    screenId: item.screenId,
                    hardwareCode: item.hardwareCode,
                    terminalState: +item.terminalState
                }));
            // 情况1：无需请求 plan，直接一次性更新 gridList
            console.log("forms.length",forms.length)
            if (forms.length === 0) {
                this.currentMaxPage = targetPage;
                // 关键：一次性赋值，触发唯一一次渲染
                this.gridList = tempGridList;
                this.gridList.forEach((item) => {
                    item.district = toDisplayDistrict(item.district);
                })
                console.log("this.gridList:一次性赋值",this.gridList)
                this.loading = false;
                return;
            }

            // 情况2：需要请求 plan，补全数据后再一次性更新 gridList
            this.$post("/monitor/getScreenPlanSpeedV4", {forms}, {timeout: 30000})
                .then((res) => {
                    if (res.rescode === 200) {
                        // 1. 在临时完整列表中补全 plan 数据（不修改真实的 gridList）
                        const dataList = res.data?.dataList || [];
                        const completeTempGridList = tempGridList.map(item => {
                            const plan = dataList.find(p => p.mediaId === item.screenId) || {};
                            return {
                                ...item,
                                ...plan,
                            };
                        });

                        // 2. 所有数据构造完成！一次性赋值给 gridList，触发渲染
                        this.gridList = completeTempGridList;
                        this.gridList.forEach((item) => {
                            item.district = toDisplayDistrict(item.district);
                        })
                        console.log("this.gridList",this.gridList)
                        this.currentMaxPage = targetPage;
                    }else {
                        this.$toast(res.msg || '获取 plan 数据失败');
                        // 页码回滚：plan 请求失败，恢复上一页页码
                        this.filterForm.pageNum -= 1;
                    }
                })
                .catch(error => {
                    console.log(error);
                    // 页码回滚：plan 请求异常，恢复上一页页码
                    this.filterForm.pageNum -= 1;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
    filters: {
        dictionary(value, dict) {
            return dict[value] || value;
        },
    },
};
</script>

<style scoped>
.page-container {
    height: 100vh;
    display: flex;
    flex-direction: column;
}

.bottom-menu {
    height: 50px;
    line-height: 50px;
    text-align: center;
    background-color: #fff;
    border-top: 1px solid #f0f0f0;
    z-index: 99;
}

.mobileBox {
    flex: 1;
    overflow: hidden;
    background-color: #ffffff;
    position: relative;
    z-index: 1;
}

.filter-section {
    padding: 10px 12px;
    background-color: #fff;
    border-bottom: 1px solid #f0f0f0;
}

.filter-row {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 8px;
}

.filter-row:last-child {
    margin-bottom: 0;
}

.filter-input {
    flex: 1;
}

.filter-select {
    flex: 1;
}

.filter-input ::v-deep .el-input-group__append {
    background-color: #409eff;
    border-color: #409eff;
    color: #fff;
    padding: 0 12px;
}

.filter-input ::v-deep .el-input-group__append .el-button {
    color: #fff;
}

.filter-input ::v-deep .el-input-group__append .el-button:hover {
    color: #fff;
}

.content-loading {
    z-index: 10 !important;
}

.mobile {
    height: 100%;
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    background-color: #ffffff;
    padding: 12px;
    box-sizing: border-box;
    padding-bottom: 50px;
}

.mobile::-webkit-scrollbar {
    display: none;
}

/* 核心修改：将卡片改为长方形（参考图片比例，设置合理宽高比） */
.cneten {
    position: relative;
    width: 100%; /* 宽度占满容器，贴合参考图片 */
    /* 关键：用 padding-bottom 实现长方形宽高比（示例为 16:9，可根据图片调整：高度=宽度*比例） */
    /* 16:9 对应 padding-bottom: 56.25%; 4:3 对应 75%; 参考图片近似 5:3 对应 60%，可按需微调 */
    padding-bottom: 56.25%;
    height: 0; /* 高度设为 0，由 padding-bottom 撑起，保证宽高比不变 */
    background: #0e0e0e;
    margin-bottom: 16px;
    font-size: 12px;
    border-radius: 8px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
}

/* 图片和占位符适配长方形卡片 */
.player, .monitor-placeholder {
    position: absolute; /* 绝对定位填充整个长方形卡片 */
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 8px;
    object-fit: fill; /* 图片填充方式，保持原效果 */
}

.monitor-placeholder {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #666666;
    background: #f8f8f8;
}

.status {
    position: absolute;
    top: 0;
    left: 0;
    color: #ffffff;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1;
    padding: 6px;
    display: flex;
    align-items: center;
    gap: 6px;
}

.circle {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    position: relative;
}

.circle::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 8px;
    height: 8px;
    border-radius: 50%;
    opacity: 0.7;
    animation: scale 2s infinite cubic-bezier(0, 0, 0.49, 1.02);
    animation-delay: 200ms;
}

@keyframes scale {
    0% {
        transform: scale(1) translate(-50%, -50%);
    }
    50%,
    75% {
        transform: scale(2.5) translate(-50%, -50%);
    }
    78%,
    100% {
        opacity: 0;
    }
}

.success {
    background-color: #52c41a;
}

.success::before {
    background-color: #52c41a;
}

.error {
    background-color: #f5222d;
}

.error::before {
    background-color: #f5222d;
}

.warning {
    background-color: #fadb14;
}

.warning::before {
    background-color: #fadb14;
}

.tag {
    position: absolute;
    bottom: 0;
    left: 0;
    color: #ffffff;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1;
    padding: 6px;
}

.modle {
    position: absolute;
    top: 0;
    right: 0;
    color: #ffffff;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1;
    padding: 6px;
}

.playTypeTag {
    position: absolute;
    top: 2px;
    right: 2px;
    background-color: transparent !important;
    border-color: #409eff !important;
    color: #409eff !important;
    z-index: 1;
}

/* 全屏预览样式 */
.preview-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.9);
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
}

.preview-close {
    position: absolute;
    top: 20px;
    right: 20px;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 10000;
    transition: background 0.3s;
}

.preview-close:hover {
    background: rgba(255, 255, 255, 0.3);
}

.preview-close i {
    font-size: 24px;
    color: #fff;
}

.preview-content {
    background: #0e0e0e;
}

.preview-media {
    width: 100%;
    height: 100%;
    object-fit: contain;
}
</style>
